import React, { Component } from 'react';
import { Grid, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  titleTxt: {
    fontSize: 30,
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    margin: 0,
    padding: '50px 0 30px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 0),
      fontSize: 20,
    },
  },
  txtBorder: { margin: 0, width: '70px', height: '3px', backgroundColor: theme.palette.primary.main },
  narrowPaddingTitle: {
    fontSize: 30,
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    margin: 0,
    padding: theme.spacing(2, 0, 3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 0, 3),
      fontSize: 20,
    },
  },
  traceDetailTitle: {
    display: 'block',
    fontSize: 30,
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    margin: 0,
    padding: theme.spacing(2, 0, 1),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      padding: theme.spacing(1, 0, 1),
      fontSize: 20,
    },
  },
});

class TitleText extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, title, type } = this.props;
    return (
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        className={
          type === 'narrowPadding' ? classes.narrowPaddingTitle : type === 'traceDetail' ? classes.traceDetailTitle : classes.titleTxt
        }
      >
        <p style={{ margin: 0, paddingBottom: 10, fontWeight: 900 }}>{title}</p>
        <p className={classes.txtBorder} />
      </Grid>
    );
  }
}

export default withStyles(styles, { withTheme: true })(TitleText);
